import React from 'react';
//import logo from './logo.svg';
import './App.css'

import {
  BrowserRouter as Router,
  Switch,
  Route
} from 'react-router-dom'
import Tournament from './components/Tournament'
import StandingsOnly from './components/StandingsOnly'
import SlamTournament from './components/SlamTournament'


function App() {

  
  //basename={"/leaderboard"}
  //  //"homepage": "https://test.tourneyx.com/leaderboard", add this in package.json
  return (
    <>
    <Router basename={"/leaderboard"}> 
      <Switch>          
        
        {
          /*
          <Route exact path="/standings/:tournamentId" render={(props) => <Tournament {...props}/> }/> 
           */
        }
  
        <Route exact path="/standings/:slug" render={(props) => <Tournament {...props}/> }/> 
         
      
        <Route exact path="/slam/:tournamentId" render={(props) => <Tournament {...props}/> }/>
        <Route exact path="/standings-view/:tournamentId" render={(props) => <Tournament {...props}/> }/>
        <Route exact path="/tournament/:tournamentId" render={(props) => <Tournament {...props}/> }/>
        <Route exact path="/standings-only/:tournamentId" render={(props) => <StandingsOnly {...props} />}/>
        <Route exact path="/slam/:tournamentId" render={(props) => <SlamTournament {...props} />}/>
      </Switch>
    </Router>
    </>
  );
}

export default App;
